import * as helper from './../../../Assets/Js/helper';
import {getUsernameById} from '../../../Assets/Js/Usernames';

interface IMessage {
	message: string;
	time: number;
	userid: number;
}

export function Chat() {
	const fakeChats = [
		"echt geile Braut",
		"du bist mega hübsch Süße!",
		"Bei dir würde ich nicht nein sagen!",
		"Dich würde ich nicht von der Bettkante schubsen.",
		"mein Schwanz ist schon ganz hart",
		"boah bin ich hart",
		"gleich passierts!!!",
		"mach weiter so, ich komm gleich",
		"Gleich spritz ich ab!",
		"Du bist ein Traum! <3",
		"klasse Frau!!!",
		"dich würde ich so richtig verwöhnen",
		"mein harter Lümmel würde dir gefallen",
		"wenn du jetzt sehen könntest wie mein Schwanz auf dich reagiert ;-)",
		"würd dich jetzt gern ficken!!!!",
		"echt krasser Scheiss hier",
		"extrem geil wie du das machst",
		"glaub ich bin im Himmel :-D",
		"muss los! komme aber auf jeden Fall wieder!!!",
		"geil-o-mat",
		"Traumfrau!",
		"Sexy!",
		"rattenscharf",
		"Scharfes Geschoss!",
		"Mist! Ganz die Zeit vergessen. Wir sehen uns...definitiv!",
		"darf ich dich vernaschen?",
		"<3 <3 <3",
		"Du raubst mir den Verstand Süße!!!!",
		"Hallo. Das ist ja ne geile Nummer hier :-o",
		"lauter heiße Chiccas hier",
		"eine geiler als die andere",
		"danke für gestern Abend Süße, das war echt ne geile Nummer! Komme nachher wieder...",
		"meine neue Lieblingsseite hier ;-)",
	];
	helper.shuffleArray(fakeChats);

	const wrapper = helper.$('#wrapper');
	const video: HTMLVideoElement = document.querySelector('video');
	let count = 0;
	let lastPlay = 0;
	const chatContent = document.querySelector('.model-chat-content');
	const messages: IMessage[] = JSON.parse(helper.getData(wrapper, 'messages'));

	const template = `<div class="message">
						<div class="message-left">
							<div class="message-avatar">
								<img class="message-avatar-img" src="/VX/ProfileChat/img/placeholder_male.jpg" alt="">
							</div>
						</div>
						<div class="message-right">
							<div class="message-username">
								USERNAME
							</div>
							<div class="message-bubble message-bubble-others">
								MESSAGE
							</div>
							<div class="message-period">
								gerade eben
							</div>
						</div>
					</div>`

	video.ontimeupdate = (event) => {
		const seconds = Math.round(event.timeStamp / 1000);
		if (count < seconds) {
			count = seconds;
		}
		if (messages.length > 0 && messages[0].time <= count) {
			lastPlay = count;
			const currentMessage = messages.shift();
			const message = template
								.replace('MESSAGE', currentMessage.message)
								.replace('USERNAME', getUsernameById(currentMessage.userid));
			chatContent.append(helper.stringToHtml(message));
			chatContent.scrollTop = chatContent.scrollHeight;
		} else if (messages.length === 0 && helper.hasClass(chatContent, 'blur')) {
			if (Math.random() * 100 > 98) {
				const target = Math.ceil(Math.random() * 6);
				let info = '';

				for (let n = 0; n < target; n++) {
					info += Math.random().toString(36) + ' ';
				}

				const message = template.replace('MESSAGE', info)
										.replace('USERNAME', Math.random().toString(36) + ' ');
				chatContent.append(helper.stringToHtml(message));
				chatContent.scrollTop = chatContent.scrollHeight;
			}
		} else if (seconds > lastPlay + 7 && fakeChats.length > 0) {
			lastPlay = count;
			const currentMessage = fakeChats.shift();
			const message = template.replace('MESSAGE', currentMessage)
									.replace('USERNAME', getUsernameById(Math.floor(Math.random() * 5)));
			chatContent.append(helper.stringToHtml(message));
			chatContent.scrollTop = chatContent.scrollHeight;
		}
	}
}
